export class RangeOnLineConnectionTypeDef {
  public static readonly TYPE_DRILLING_HOLE: string = 'drillingHole';
}
